module.exports = __webpack_public_path__ + "img/lunbo21.15066bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo21.jpg
// module id = /pNm
// module chunks = 0